import React from "react";

const TimelineMainContent = () => {
  return (
    <div className=" page-main">
      <div className=" main-content container-fluid w-100">
        Timeline MainContent
      </div>
    </div>
  );
};

export default TimelineMainContent;
